import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { shareService } from '../services/shareService';
import type { CreateShareDto } from '../types';

export function useCreateShare() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('shares');

  return useMutation({
    mutationFn: (data: CreateShareDto) => shareService.create(data),
    onSuccess: (_share, variables) => {
      queryClient.invalidateQueries({ queryKey: ['shares'] });
      const title =
        variables.kind === 'link'
          ? t('toasts.createSuccessLink')
          : t('toasts.createSuccessUser');
      toast.success({ title });
    },
    onError: () => {
      toast.danger({ title: t('toasts.createError') });
    },
  });
}
